import React, { createContext, useContext, useState, useEffect } from 'react';

// Crear el contexto
const AuthContext = createContext();

// Proveedor de contexto
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // Estado para el usuario
    const [isAuthenticated, setIsAuthenticated] = useState(false); // Estado para saber si está autenticado

    // Actualizar el estado según el login
    const login = (userData) => {
        setUser(userData);
        setIsAuthenticated(true);
    };

    // Desconectar usuario
    const logout = () => {
        setUser(null);
        setIsAuthenticated(false);
    };

    // Contexto de valores
    return (
        <AuthContext.Provider value={{ user, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook para usar el contexto
export const useAuth = () => {
    return useContext(AuthContext);
};
